import { useState } from 'react';

import type { SaveListItem } from '../../../../types/save-types.js';
import type { ClickUIElementInputObject } from '@schibsted/pulse-news-media';

import { usePulseContext } from '../../../../../core/mandatory-integrations/pulse/PulseProvider.js';

export function useTeaserSaveOverlay(
  listTeaser: SaveListItem,
  trackObject: ClickUIElementInputObject,
) {
  const [overlay, toggleOverlay] = useState({
    overlayVisible: false,
    itemToSave: listTeaser,
  });

  const { trackClickUIElement } = usePulseContext();

  const handleOverlay = () => {
    trackClickUIElement({
      object: {
        ...trackObject,
      },
    }).finally(() => {
      toggleOverlay({
        overlayVisible: !overlay.overlayVisible,
        itemToSave: listTeaser,
      });
    });
  };

  const handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    handleOverlay();
  };

  return {
    overlay,
    toggleOverlay,
    handleSave,
    handleOverlay,
  };
}
